
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vs-xero",
      function () {
        return require("private-next-pages/vs-xero.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vs-xero"])
      });
    }
  